/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IEdmModel } from '../models/IEdmModel';
import type { ODataServiceDocument } from '../models/ODataServiceDocument';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MetadataService {

    /**
     * @returns IEdmModel Success
     * @throws ApiError
     */
    public static odataMetadata(): CancelablePromise<IEdmModel> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/odata/$metadata',
        });
    }

    /**
     * @returns ODataServiceDocument Success
     * @throws ApiError
     */
    public static odata(): CancelablePromise<ODataServiceDocument> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/odata',
        });
    }

}
